import React from 'react';
import PropTypes from 'prop-types';

import TypeTextInput from 'v1/components/shared/byType/text/TextInput/__types__/TypeTextInput';
import { TextInputProps } from 'v1/components/shared/byType/text/TextInput/__types__/TextInput';
import { TextInput } from 'v1/components/shared';

interface PhoneInputProps extends Omit<TextInputProps, 'onChange'> {
  showOverlay?: boolean;
  onChange?(value: string | null): void;
}

const PhoneInput = ({
  placeholder,
  value,
  showOverlay = true,
  onChange,
  ...props
}: PhoneInputProps) => {
  // Prevent some props being spread
  const { type, ...rest } = props;

  const handleChange = ({
    target: { value }
  }: React.ChangeEvent<HTMLInputElement>): void => {
    onChange && onChange(value);
  };

  const label = showOverlay && value ? value : undefined;
  const overlayAction = showOverlay ? `tel:${value}` : null;

  return (
    <TextInput
      type="tel"
      placeholder={placeholder !== undefined ? placeholder : 'Phone number'}
      value={value}
      overlayLabel={label}
      overlayAction={overlayAction}
      onChange={handleChange}
      {...rest}
    />
  );
};

PhoneInput.propTypes = {
  ...TypeTextInput,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  showOverlay: PropTypes.bool,
  onChange: PropTypes.func
  // Inherits standard TextInput & HTML input properties
};

export default PhoneInput;
